import React from 'react';

import { CHEVRON_RIGHT_ICON } from '../../../../constants/images';
import { IBdsNavigationCard } from '../../../../interfaces/cards';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';
import './BdsNavigationCard.scss';

const BdsNavigationCard = ({ isDisabled, leadingIcon, title, action }: IBdsNavigationCard) => {
  const onIconClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    action();
  };

  return (
    <button className="navigation-card" data-experience="new" disabled={isDisabled} onClick={action}>
      <div className="navigation-card-leading-content">
        {<leadingIcon.component className="navigation-card-leading-content-icon" data-testid="leading-icon" />}
        <p className="navigation-card-leading-content-title">{title}</p>
      </div>
      <div className="navigation-card-tailing-icon-button">
        <BdsIconButton
          size="sm"
          disabled={isDisabled}
          action={onIconClick}
          variant="primary"
          icon={CHEVRON_RIGHT_ICON}
        />
      </div>
    </button>
  );
};

export default BdsNavigationCard;
